module.exports = __webpack_public_path__ + "img/page.bfcf8b3c.png";